module.exports = function(app){
    app.controller("pages.vision-health.vision-wellness", ["$scope", "$state", "modal", function($scope, $state, modal){

        $scope.usesDViframes = function(state){
            return["vision-health.vision-claims",
                    "vision-health.eye-care-provider",
                    "vision-health.vision-eligibility",
                    "vision-health.laser-vision"].indexOf(state) > -1;
        };

        $scope.popVisionModal = function() {
            modal.open({
                templateUrl: '_modals/visionModal.appTemplate.html/chmhom/modals/visionModal',
                scope: $scope
            })
        };

        $scope.visionLinks = [
            "MBR_VISION_HEALTH_NAVIGATION_LINK2",
            "MBR_VISION_HEALTH_NAVIGATION_LINK3",
            "MBR_VISION_HEALTH_NAVIGATION_LINK4",
            "MBR_VISION_HEALTH_NAVIGATION_LINK5",
            "MBR_VISION_HEALTH_NAVIGATION_LINK6",
            "MBR_VISION_HEALTH_NAVIGATION_LINK7"
        ]
    }]);
};